/*
 * @Author: jiangzhengjie
 * @Description: 样式可控弹窗 标题默认居中字体16px平方regular#222色号 离顶部20px 
    关闭按钮宽高24px，绝对定位右上各16px
 * 不想写bug  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template>
  <ts-popup
    show="{{show}}"
    position="bottom"
    bind:close="close"
    closeable="{{closeable}}"
    showMask="{{showMask}}"
    isDrawer
    simple="{{simple}}"
    maskStyle="{{maskStyle}}"
    externClass="externClass"
  >
    <view class="drawer-container" wx:style="{{externStyle}}">
      <view wx:if="{{useSimpleHeader && title}}" class="header" wx:style="{{computedHeaderStyle}}">
        {{ title }}
      </view>
      <view wx:elif="{{!useSimpleHeader}}" class="header" wx:style="{{computedHeaderStyle}}">
         <slot name="left" />
      </view>
      <slot />
      <view         
        wx:if="{{showCloseBtn}}"
        class="close-icon"
        wx:style="{{iconStyle}}"
        bindtap="close"
        >
        <spring-icon wx:if="{{useDefaultIcon}}" size="{{iconSize}}" color="#333" name="close"/>
        <slot wx:else name="close-icon" />
      </view>
    </view>
  </ts-popup>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  props: {
    show: {
      type: Boolean,
      value: false
    },
    title: {
      type: String,
      value: ''
    },
    // 如果都给paddingleft存在靠左标题现实问题
    centerTitle: {
      type: Boolean,
      value: false
    },
    iconSize: {
      type: Number,
      value: 48
    },
    iconStyle: {
      type: Object,
      value: {}
    },
    externClass: {
      type: String,
      value: ''
    },
    externStyle: {
      type: Object,
      value: () => {}
    },
    headerStyle: {
      type: Object,
      value: {}
    },
    showMask: {
      type: Boolean,
      value: false
    },
    closeable: {
      type: Boolean,
      value: true
    },
    maskStyle: {
      type: Object,
      value: () => {}
    },
    showCloseBtn: {
      type: Boolean,
      value: true
    },
    // 默认简单标题 反之传slot
    useSimpleHeader: {
      type: Boolean,
      value: true
    },
    useDefaultIcon: {
      type: Boolean,
      value: true
    },
    // 遮罩点击是否可以关闭
    closeable: {
      type: Boolean,
      value: true
    },
    simple: {
      type: Boolean,
      value: false
    }
  },
  data() {
    return {}
  },
  computed: {
    computedHeaderStyle() {
      return this.useDefaultIcon ? {
        'padding-right': '60px',
        'padding-left': this.centerTitle ? '60px' : '0',
        ...this.headerStyle
      } : this.headerStyle
    },
  },
  methods: {
    close(e) {
      const closeType = e?.detail?.type || 'button'
      this.triggerEvent('close', {
        type: closeType
      })
    }
  }
})
</script>

<style lang="stylus" scoped>
.drawer-container
  min-height 100px
  background #ffffff
  border-radius 10px 10px 0 0
  display flex
  flex-direction column
  position relative
  .header
    width 100%
    display flex
    box-sizing border-box
    font-family PingFangSC-Regular
    justify-content center
    font-size 16px
    line-height 1.2
    padding-top 20px
    color #222
  .close-icon
    position absolute
    color #333
    top 15px
    right 16px
</style>
<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'ts-popup': '../ts-popup/index',
    'spring-icon': '@didi/spring-icon'
  }
}
</script>
